import { GoogleCalendarIntegration } from './GoogleCalendarIntegration';
import { SlackIntegration } from './SlackIntegration';

export function Integrations(): JSX.Element {
  return (
    <div className="flex flex-col gap-4 w-full mt-6">
      <GoogleCalendarIntegration />
      <SlackIntegration />
    </div>
  );
}

export default Integrations;
